module.exports = __webpack_public_path__ + "static/img/pause_circle.51edd743.png";